import { css as cssStyles, styled, Tooltip } from 'canoe';
import React from 'react';

import { TextButton, ValueBox, ValueToggle } from '@candu-ai/craft/ui';
import { useResponsiveCss } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

const StateLabel = styled.div`
  ${({ theme }) => cssStyles`
    padding: 0 ${theme.spaces.xs};
  `}
`;

const data = [
  {
    tooltip: 'Show content that is larger than its container',
    cssProp: 'visible',
    label: 'Show',
  },
  {
    tooltip: 'Hide content that is larger than its container',
    cssProp: 'hidden',
    label: 'Hide',
  },
  {
    tooltip: 'Show scrollbars if content is larger than its container',
    cssProp: 'scroll',
    label: 'Scroll',
  },
  {
    tooltip: 'Automatically add scrollbars if content overflows',
    cssProp: 'auto',
    label: 'Auto',
  },
];

interface Props {
  nodeIds: string[];
  cssSelectorId?: CssSelectorId;
}

export const Overflow = ({ nodeIds, cssSelectorId }: Props) => {
  const { responsiveCss, setResponsiveCss } = useResponsiveCss(nodeIds, undefined, cssSelectorId);
  const { overflow } = responsiveCss;
  const updateCss = (payload: Record<string, unknown>) => setResponsiveCss(payload);
  const resetCss = () => setResponsiveCss({ overflow: undefined });
  return (
    <>
      <ValueBox label="Overflow" responsiveToggle>
        {data.map(({ tooltip, cssProp, label }) => (
          <ValueToggle
            key={cssProp}
            toggleGroup="overflow"
            onClick={() => updateCss({ overflow: cssProp })}
            isActive={(overflow || 'visible') === cssProp}
            label={
              <Tooltip content={tooltip} placement="top" offset="xxs">
                <StateLabel>{label}</StateLabel>
              </Tooltip>
            }
          />
        ))}
      </ValueBox>
      <TextButton onClick={resetCss}>Reset</TextButton>
    </>
  );
};
